import { Skeleton } from '@redriverpress/system'

import VideosGrid from '../VideosGrid'

const placeholders = [...new Array(24)].map((_, index) => ({ key: index }))

export default function VideosSkeleton() {
  return (
    <VideosGrid>
      {placeholders.map(ph => (
        <Skeleton
          key={ph.key}
          height='12rem'
          width='100%'
          borderRadius='rounded'
        />
      ))}
    </VideosGrid>
  )
}
